'use client';

import { QueryClient, QueryClientProvider as ReactQueryClientProvider } from '@tanstack/react-query';
import { usePathname } from 'next/navigation';
import { type ReactNode, useEffect, useState } from 'react';
import { COOKIES } from '@src/utils/constants.util';
import { getBrowserCookie } from '@src/utils/cookies.util';
import { defaultQueryClientConfigs } from '@src/utils/query.util';
export function QueryClientProvider({
  children
}: {
  children: ReactNode;
}) {
  const [queryClient] = useState(() => new QueryClient(defaultQueryClientConfigs));
  // This root-layout provider never remounts, so re-check the inspect cookie on navigation.
  const pathname = usePathname();
  useEffect(() => {
    if (getBrowserCookie(COOKIES.inspectEnabled) !== 'true') return;
    window.BODi ??= {
      user: {
        isLoggedIn: false
      }
    };
    window.BODi.serverData ??= {};
    const syncQueries = () => {
      window.BODi!.serverData!.queries = Object.fromEntries(queryClient.getQueryCache().getAll().map(query => [JSON.stringify(query.queryKey), query.state.data]));
    };
    syncQueries();
    return queryClient.getQueryCache().subscribe(syncQueries);
  }, [queryClient, pathname]);
  return <ReactQueryClientProvider client={queryClient}>{children}</ReactQueryClientProvider>;
}